module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-wave-9becc473c8434fb445a84fa8161e2a5d.svg";